export var ParentEnvelopeHostPattern;
(function (ParentEnvelopeHostPattern) {
    ParentEnvelopeHostPattern["DEV_INT"] = "dev.intl.paramountplus.com";
    ParentEnvelopeHostPattern["LOCALHOST"] = "localhost";
    ParentEnvelopeHostPattern["PREVIEW_CBS"] = "preview.cbs.com";
    ParentEnvelopeHostPattern["PREVIEW_INT"] = "preview.intl.paramountplus.com";
    ParentEnvelopeHostPattern["PREVIEW_PPLUS"] = "preview.paramountplus.com";
    ParentEnvelopeHostPattern["PROD_CBS"] = "www.cbs.com";
    ParentEnvelopeHostPattern["PROD_INT"] = "intl.paramountplus.com";
    ParentEnvelopeHostPattern["PROD_PPLUS"] = "www.paramountplus.com";
    ParentEnvelopeHostPattern["SHADOW_CBS"] = "shadow.cbs.com";
    ParentEnvelopeHostPattern["SHADOW_INT"] = "shadow.intl.paramountplus.com";
    ParentEnvelopeHostPattern["SHADOW_PPLUS"] = "shadow.paramountplus.com";
    ParentEnvelopeHostPattern["STAGE_CBS"] = "stage.cbs.com";
    ParentEnvelopeHostPattern["STAGE_INT"] = "stage.intl.paramountplus.com";
    ParentEnvelopeHostPattern["STAGE_PPLUS"] = "stage.paramountplus.com";
    ParentEnvelopeHostPattern["TEST_WWW_CBS"] = "test-www.cbs.com";
    ParentEnvelopeHostPattern["TEST_WWW_PPLUS"] = "test-www.paramountplus.com";
    ParentEnvelopeHostPattern["VIDOPSTEST_CBS"] = "vidopstest.cbs.com";
    ParentEnvelopeHostPattern["VIDOPSTEST_INT"] = "vidopstest.intl.paramountplus.com";
    ParentEnvelopeHostPattern["VIDOPSTEST_PPLUS"] = "vidopstest.paramountplus.com";
})(ParentEnvelopeHostPattern || (ParentEnvelopeHostPattern = {}));
